/* ============================================================
   NATIVOS — Custom JS
   Chargé via snippets/nativos-head.liquid (defer)
   Pas de jQuery. ES6+ uniquement.
   ============================================================ */

function nativosInitShippingBar(bar) {
  const threshold = parseFloat(bar.getAttribute('threshold')) || 0;
  const totalPrice = parseFloat(bar.getAttribute('total-price')) || 0;
  const progress = threshold > 0 ? Math.min(totalPrice / threshold, 1) : 0;

  // Barre
  let track = bar.querySelector('.nativos-progress-track');
  if (!track) {
    track = document.createElement('div');
    track.className = 'nativos-progress-track';
    track.innerHTML = '<div class="nativos-progress-bar"></div>';
    bar.appendChild(track);
  }
  track.querySelector('.nativos-progress-bar').style.width = (progress * 100) + '%';
}

function nativosAttachShippingBar(bar) {
  nativosInitShippingBar(bar);
  new MutationObserver(() => nativosInitShippingBar(bar))
    .observe(bar, { attributes: true, attributeFilter: ['total-price'] });
}

// MutationObserver sur body — détecte l'insertion de free-shipping-bar (lazy-loaded avec la drawer)
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      const bar = node.matches?.('free-shipping-bar') ? node : node.querySelector?.('free-shipping-bar');
      if (bar) nativosAttachShippingBar(bar);
    }
  }
}).observe(document.body, { childList: true, subtree: true });

// Cas où l'élément est déjà dans le DOM au chargement
const nativosBarOnLoad = document.querySelector('free-shipping-bar');
if (nativosBarOnLoad) nativosAttachShippingBar(nativosBarOnLoad);

document.addEventListener('cart:change', () => {
  const bar = document.querySelector('free-shipping-bar');
  if (bar) nativosInitShippingBar(bar);
});

/* ============================================================
   Pictos sur les boutons de mouture (option Shopify « Mouture »)
   Les libellés viennent du sélecteur natif Prestige : on ajoute
   l'icône correspondante devant le texte, sans toucher au thème.
   ============================================================ */
const NATIVOS_MOUTURE_ICONS = {
  'grains': '<ellipse cx="16" cy="16" rx="7" ry="10" transform="rotate(-30 16 16)"/><path d="M20.5 8.5c-4 3-4.5 6.5-2 8.5s1.5 5.5-2.5 7.5"/>',
  'v60': '<path d="M6 8h20l-7 10h-6z"/><path d="M13 18v2h6v-2"/><path d="M8 22h16"/><path d="M10 22v4.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5V22"/>',
  'chemex': '<path d="M9 4h14l-5 11 5 13H9l5-13z"/><path d="M11.2 10h9.6"/><path d="M13.4 13h5.2l-1 2h-3.2z"/>',
  'espresso': '<path d="M9 13h12v5a6 6 0 0 1-12 0z"/><path d="M21 14.5h1.5a2.5 2.5 0 0 1 0 5H20.5"/><path d="M6 26h19"/><path d="M13 6c-1 1.2 1 2.3 0 3.5M17 6c-1 1.2 1 2.3 0 3.5"/>',
  'moka': '<path d="M11 4h10l2 10H9z"/><path d="M9 14h14"/><path d="M12 16l-3 12h14l-3-12"/><path d="M23 7h2.5v6"/><path d="M11 4l-2.5-1.5"/>',
  'piston': '<rect x="9" y="9" width="12" height="19" rx="1"/><path d="M15 3v17"/><path d="M12.5 3h5"/><path d="M10 20h10"/><path d="M21 12h2a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2"/>'
};

function nativosDecorateMouture(root) {
  const labels = (root || document).querySelectorAll('.block-swatch:not([data-nativos-mouture])');
  labels.forEach((label) => {
    const key = label.textContent.trim().toLowerCase();
    const paths = NATIVOS_MOUTURE_ICONS[key];
    if (!paths) return;
    label.dataset.nativosMouture = 'true';
    label.classList.add('nativos-mouture-swatch');
    label.insertAdjacentHTML('afterbegin',
      '<svg class="nativos-mouture-swatch__icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>');
  });
}

nativosDecorateMouture();

// Prestige recrée le sélecteur au changement de variante : on redécore les nouveaux boutons
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.('.block-swatch') || node.querySelector?.('.block-swatch')) {
        nativosDecorateMouture(node.parentElement || node);
      }
    }
  }
}).observe(document.body, { childList: true, subtree: true });
